<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="my-3 mx-2">
      <div class="p-3 border rounded" style="background-color: white;">
        <div class="p-2 d-flex flex-row" style="align-items: center;">
          <h3 class="me-auto">All Notifications </h3>
          <a class="ms-2" href="javascript:void(0)" @click="updateNotificationStatusData">
            Mark All as Read
          </a>
        </div>
        <!-- page size  -->
        <b-row class="mt-2">
          <b-col class="col-4 p-1" lg="3" md="4">
            <b-form-group class="ms-2">
              <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                             class="col-md-4" size="sm" @change="handlePageSizeChange"></b-form-select>
            </b-form-group>
          </b-col>
          <!-- search  -->
          <b-col>
            <div class="d-flex flex-row d-flex justify-content-end">
              <b-form-input v-model="filter" class="me-2" placeholder="Type to filter data" style="width: 30%;"
                            type="search"></b-form-input>
              <button class="rounded btn-info me-4" @click="onSearch">Search</button>
            </div>
          </b-col>
        </b-row>
        <div v-if="showMessageModal">
          <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
               class="modal fade show" role="dialog" style="display: block;"
               tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 id="exampleModalFullscreenLabel" class="modal-title h4">{{
                      selectedNotification.subject
                    }}</h5>
                  <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                          @click="showMessageModal = false"></button>
                </div>
                <div class="modal-body">
                  <div v-html="selectedNotification.message"></div>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                          @click="showMessageModal = false">Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="showEmail">
          <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
               class="modal fade show" role="dialog" style="display: block;"
               tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 id="exampleModalFullscreenLabel" class="modal-title h4">{{
                      selectedNotification.subject
                    }}</h5>
                  <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                          @click="showEmail = false"></button>
                </div>
                <div class="modal-body">
                  <div v-html="selectedNotification.message"></div>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                          @click="showEmail = false">Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-table :busy="loading" :fields="fields" :items="emailList" :per-page="perPage" bordered hover striped>
          <template #cell(status)="row">
            <div class="px-2">
              <div v-if="row.item.status == 'PUBLISHED'" class="badge bg-success">
                Published
              </div>
              <div v-else-if="row.item.status == 'DRAFT'" class="badge bg-warning">
                Draft
              </div>
            </div>
          </template>
          <template #cell(actions)="row">
            <div v-if="row.item.type == 'post'" class="d-flex gap-1 justify-content-center mt-2">
              <button class="btn btn-success btn-sm me-2" title="View Content Body" type="button"
                      @click="showModal(row.item)">
                <i class="fa-solid fa-eye"></i>
              </button>
              <button class="btn btn-sm" style="background-color:  rgb(61, 12, 97);" title="Go to content page"
                      type="button">
                <router-link :to="`/${row.item.name + '/edit/' + row.item.reference_id}`"
                             class="content">
                  <i class="fa-solid fa-share" style="color: white;"></i>
                </router-link>
              </button>
            </div>
            <div v-else class="mt-2">
              <button class="btn btn-success btn-sm me-2" title="View content"
                      type="button" @click="showEmailModal(row.item)">
                <i class="fa-solid fa-eye"></i>
              </button>
              <button class="btn btn-info btn-sm" title="Write email to this user"
                      @click="openDefaultEmailClient">
                <i class="fa-solid fa-paper-plane"></i>
              </button>
              <button v-if="row.item.user_create_yn === 'Y'" class="ms-2 btn btn-warning btn-sm"
                      title="Resend this email"
                      @click="resendUserCreateMail(row.item.id)">
                <i class="fa-solid fa-envelope"></i>
              </button>
            </div>
          </template>
          <!-- <template #cell(myMessage)="row">
              <div>
                  <div v-if="row.item.type == 'post'" v-html="row.item.message"></div>
              </div>
          </template> -->
          <template #table-busy>
            <div class="text-center text-danger my-2 px-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
        <!-- Pagination -->
        <b-row>
          <b-col class="mt-2" md="12" sm="12">
            <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" align="center"
                          class="my-0" next-text="Next" prev-text="Prev"
                          @click="handlePageChange"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardService from "@/services/dashboard.service";
import moment from "moment";
import {notify} from '@kyvg/vue3-notification'
import {VBTooltip} from "bootstrap-vue-3";

export default {
  setup() {
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Notification List',
          href: '#'
        }
      ],
      fields: [
        {
          label: 'Name', key: 'name', sortable: true, thStyle: {width: "10%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Email', key: 'email_to', sortable: true,
          thStyle: {width: "20%"}, tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Subject', key: 'subject', sortable: true, thStyle: {width: "20%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Status', key: 'status', sortable: false,
          class: 'text-center',
          filterByFormatted: true
        },
        {
          label: 'User', key: 'user_name', sortable: false,
          class: 'text-center', thStyle: {width: "20%"},
          filterByFormatted: true
        },
        {
          key: 'insert_date', label: 'Date', class: 'text-center', thStyle: {width: "15%"},
          formatter: (data) => {
            if (data != null) {
              return moment(data).format('DD-MMM-yyyy, hh:mm A');
            } else {
              return "N/A";
            }

          },
        },
        {key: 'actions', label: 'Actions', class: 'text-center', thStyle: {width: "10%"},},
      ],
      totalRows: 1,
      // currentPage: 18,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 100],
      filter: null,
      loading: false,
      emailList: [],
      selectedNotification: null,
      showEmail: false,
      showMessageModal: false,
    };
  },
  watch: {
    filter(data) {
      this.onSearch();
      return data;
    }
  },
  async created() {
    await this.getNotificationData();
  },
  methods: {
    showModal(selectedNotification) {
      this.showEmail = false;
      this.showMessageModal = true;
      this.selectedNotification = selectedNotification;
    },
    showEmailModal(selectedNotification) {
      this.showMessageModal = false;
      this.showEmail = true;
      this.selectedNotification = selectedNotification;
    },
    handlePageSizeChange(value) {
      this.perPage = value;
      this.currentPage = 1;
      this.getNotificationData();
    },
    async handlePageChange() {
      await this.getNotificationData();
    },
    async updateNotificationStatusData() {
      const response = await DashboardService.updateNotificationStatusData();
      if (response.data.messageCode == 1) {
        this.getNotificationData();
      }
    },
    async getNotificationData() {
      this.loading = true;
      var params = {}
      if (this.filter) {
        params = {
          'per_page': this.perPage,
          'page': this.currentPage,
          'search': this.filter
        };
      } else {
        params = {
          'per_page': this.perPage,
          'page': this.currentPage,
          'search': null
        };
      }

      try {
        const response = await DashboardService.getPaginatedNotificationData(params);
        if (response.data) {
          this.emailList = response.data.data.data;
          this.loading = false;

          var count = 0;
          this.emailList.forEach(notification => {
            if (notification.read_yn == 'N') {
              count++;
            }
          });
          localStorage.setItem("EmailCount", JSON.stringify(count));
          this.totalRows = response.data.data.total;
          this.currentPage = response.data.data.current_page;
          this.perPage = response.data.data.per_page;
        }
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Error fetching notifications",
          text: error.response.data.message,
        });
      }

    },
    openModal() {
      this.$('#loginModal').modal('show')
    },
    onSearch() {
      if (this.filter != null && this.filter != "") {
        this.emailList = [];

        this.getNotificationData();


      } else {
        this.getNotificationData();
      }
    },
    openDefaultEmailClient() {
      window.location.href = 'mailto:';
    },
    async resendUserCreateMail(id) {
      try {
        this.loading = true;
        const response = await DashboardService.resendUserCreateEmail(id);
        this.loading = false;
        if (response.data) {
          if (response.data['messageCode'] == 1) {
            notify({
              type: "success",
              title: "Resend Email",
              text: response.data.message,
            });
          } else {
            notify({
              type: "error",
              title: "Resend Email",
              text: response.data.message,
            });
          }
        } else {
          notify({
            type: "error",
            title: "Resend Email",
            text: "Resend Email failed!",
          });
        }
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Error fetching notifications",
          text: error.response.data.message,
        });
      }
    },
  },
};
</script>

<style>
.text-sx {
  font-size: 13px;
}

.small-btn {
  --bs-btn-padding-y: 0.35rem;
  --bs-btn-padding-x: 0.6rem;
  --bs-btn-font-size: 0.7rem;
}
</style>
